/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseContainerFragment} from '@amblique/contentful/app/contentful/fragments/container/base-container.fragment';

export const FullContainerFragment = gql`
  ${BaseContainerFragment}

  fragment FullContainerFragment on Container {
    ...BaseContainerFragment

    region1Collection {
      items {
        __typename
        ... on Entry {
          sys {
            id
          }
        }
      }
    }
    region1CursorCollection {
      items {
        __typename
        ... on Entry {
          sys {
            id
          }
        }
      }
    }
  }
`;
